import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CountryAutoFiling } from '@services/country-auto-filing/country-auto-filing.service';
import { AUTO_FILING_STATUSES } from '@shared/meta-data';

@Component({
  selector: 'app-country-filing-card',
  templateUrl: './country-filing-card.component.html',
  styleUrl: './country-filing-card.component.scss',
})
export class CountryFilingCardComponent {
  readonly autoFilingStatuses = AUTO_FILING_STATUSES;

  @Input({ required: true }) filing: CountryAutoFiling;
  @Input({ required: true }) label: string;
  @Input() type: 'danger' | 'warning' | 'success' | 'secondary' = 'secondary';
  @Input() amount?: number;

  @Output() makePayment = new EventEmitter<CountryAutoFiling>();

  get jurisdictionCode(): string {
    const { country_code, region_code } = this.filing;
    return region_code ? `${country_code}-${region_code}` : country_code;
  }
}
